module.exports = __webpack_public_path__ + "static/media/ic-close.0a01e627.svg";